<template>
  <div class="add-floor-flat-param-value-modal">
    <q-form @submit="onSubmit" class="modal-form">
      <div class="modal-content">
        <div class="form-field">
          <CustomSelect
            :options="floorParamTypes"
            label="Тип параметра"
            optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name"
            placeholder="Выберите тип параметра"
            :value="formData.floor_param_type_id || ''"
            @change="(value) => onChange('floor_param_type_id', value)"
            :loading="loadingParamTypes"
            required
          />
        </div>

        <div class="form-field">
          <CustomSelect
            :options="rooms"
            label="Комната"
            optionValueKey="room_id"
            optionLabelKey="room_name"
            placeholder="Выберите комнату"
            :value="formData.room_id || ''"
            @change="(value) => onChange('room_id', value)"
            :loading="loadingRooms"
            required
          />
        </div>

        <div class="form-field">
          <CustomInput
            label="Значение параметра"
            placeholder="Введите значение..."
            :value="formData.param_value"
            @change_input="(value) => onChange('param_value', value)"
            type="number"
            required
            :showClearIcon="false"
          />
        </div>
      </div>

      <div class="modal-footer">
        <CustomButton @click="closeModal" outlined :disabled="saving">
          Отмена
        </CustomButton>
        <CustomButton type="submit" :loading="saving" :disabled="!isFormValid">
          Создать
        </CustomButton>
      </div>
    </q-form>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomButton from "@/components/common/CustomButton";
import { getFloorParamTypes, getAllRooms, createFloorFlatParamValue } from "@/views/BuildingSettings/services";

export default {
  name: "AddFloorFlatParamValue",
  components: {
    CustomSelect,
    CustomInput,
    CustomButton,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        floor_param_type_id: null,
        room_id: null,
        param_value: null,
      },
      floorParamTypes: [],
      rooms: [],
      loadingParamTypes: false,
      loadingRooms: false,
      saving: false,
    };
  },
  computed: {
    isFormValid() {
      return (
        this.formData.floor_param_type_id &&
        this.formData.room_id &&
        this.formData.param_value !== null &&
        this.formData.param_value !== ""
      );
    },
  },
  async mounted() {
    await Promise.all([this.loadFloorParamTypes(), this.loadRooms()]);
  },
  methods: {
    onChange(field, value) {
      this.formData[field] = value;
    },
    async loadFloorParamTypes() {
      this.loadingParamTypes = true;
      try {
        const data = await getFloorParamTypes();
        this.floorParamTypes = data || [];
      } catch (error) {
        console.error("Ошибка при загрузке типов параметров:", error);
      } finally {
        this.loadingParamTypes = false;
      }
    },
    async loadRooms() {
      this.loadingRooms = true;
      try {
        const data = await getAllRooms();
        this.rooms = data || [];
      } catch (error) {
        console.error("Ошибка при загрузке комнат:", error);
      } finally {
        this.loadingRooms = false;
      }
    },
    async onSubmit() {
      if (!this.isFormValid) return;

      this.saving = true;
      try {
        const floor_flat_id = this.data?.floor_flat_id;
        if (!floor_flat_id) {
          this.$q.notify({
            type: "negative",
            message: "Не указан floor_flat_id",
          });
          return;
        }

        await createFloorFlatParamValue({
          floor_flat_id,
          floor_param_type_id: this.formData.floor_param_type_id,
          room_id: this.formData.room_id,
          param_value: parseFloat(this.formData.param_value),
        });

        this.$q.notify({
          type: "positive",
          message: "Запись успешно создана",
        });

        if (this.data?.onSuccess) {
          this.data.onSuccess();
        }

        this.closeModal();
      } catch (error) {
        console.error("Ошибка при создании записи:", error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.add-floor-flat-param-value-modal {
  .modal-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .form-field {
    width: 100%;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
}
</style>
